// utils/auth.js

// Get token safely
export const getAccessToken = () => {
  try {
    return localStorage.getItem('access_token') || null;
  } catch {
    return null;
  }
};

// Decode JWT safely
export const decodeToken = (token) => {
  if (!token) return null;

  try {
    const payload = token.split(".")[1];
    if (!payload) return null;

    return JSON.parse(atob(payload));
  } catch (error) {
    console.error("Token decode failed:", error);
    return null;
  }
};

// Get full user object
export const getUser = () => {
  const token = getAccessToken();
  return decodeToken(token);
};

// Optional: get only role
export const getUserRole = () => {
  const user = getUser();
  return user?.role || null;
};

// Auth check
export const isAuthenticated = () => {
  return !!getAccessToken();
};